module.exports = __webpack_public_path__ + "static/media/sga0006.4691ad2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/sgal/sga0006.jpg
// module id = 67
// module chunks = 0